/* This file is auto-generated by pitspy, it was last generated: 2025-07-05T00:50:31.527703 */


export enum PrivacyRequestStatus {
	REQUESTED = 0,
	CANCELLED,
	CONFIRMED,
	COMPLETED
}

export enum MatrixInputModeType {
	SINGLE = 0,
	MULTI
}

export enum QuestionChoiceBadge {
	NONE = 0,
	LETTERS,
	NUMBERS,
	EMOJIS
}

export enum ResponseGroupCompletion {
	BLANK = 0,
	PARTIAL,
	COMPLETE
}

export enum BoardUserRole {
	OWNER = 0,
	EDITOR,
	PARTICIPANT
}

export enum InvalidTokenReason {
	NO_ERROR = 0,
	EXPIRED,
	MISSING,
	USED,
	FOR_DIFFERENT_ACCOUNT
}

export enum SurveyIntegrationKey {
	SLACK = 'slack'
}

export enum SubQuestionType {
	SINGLE_CHOICE = 0,
	MULTIPLE_CHOICE,
	DROPDOWN
}

export enum SurveyResponseSubmittedAction {
	GO_TO_NEXT = 0,
	DONE,
	STAY_ERRORS
}

export enum BoardState {
	DRAFT = 0,
	OPEN,
	CLOSED,
	ARCHIVED
}

export enum SurveyUserRole {
	OWNER = 0,
	EDITOR,
	PARTICIPANT
}

export enum MemberInviteStatus {
	NA = 0,
	INVITED,
	REGISTERED
}

export enum RoleChoice {
	ADMIN = 'admin',
	MEMBER = 'member',
	PARTICIPANT = 'participant'
}

export enum SurveyTakeAction {
	JUMP_TO_END_PAGE = 0
}

export enum SurveyMetaType {
	STRING = 0,
	NUMBER
}

export enum ShortTextResponseValidationType {
	PHONE = 0,
	EMAIL,
	INT,
	FLOAT,
	URL,
	DATE
}

export enum QuestionDisplayStyle {
	DEFAULT = 0,
	STAR,
	DROPDOWN
}

export enum SurveyState {
	DRAFT = 0,
	OPEN,
	CLOSED,
	ARCHIVED
}

export enum BoardShareMode {
	RESTRICTED = 0,
	LINK
}

export enum SurveyResponseErrorCode {
	MISSING_REQUIRED = 0,
	OVER_LIMIT,
	UNDER_MINIMUM,
	TEXT_VALIDATION,
	INVALID_DATA
}

export enum PrivacyRequestType {
	DELETE_REQUEST = 0,
	DATA_DUMP
}

export enum ShortTextResponseSubValidationType {
	NORTH_AMERICA = 0,
	INTERNATIONAL
}

export enum ReportQuestionChartType {
	BAR = 0,
	PIE,
	LINE,
	TEXT,
	NPS,
	MATRIX,
	RANKING
}

export enum SurveyShareMode {
	RESTRICTED = 0,
	EMAIL,
	LINK
}

export enum SSOIntegrations {
	GOOGLE = 0
}

export enum SurveyResponseMode {
	ONCE_PER_DEVICE = 0,
	MULTIPLE_PER_DEVICE
}

export enum QuestionType {
	SHORT_TEXT_RESPONSE = 0,
	TEXT_RESPONSE,
	SINGLE_CHOICE,
	MULTIPLE_CHOICE,
	NPS,
	RATING,
	STAR_RATING,
	DROPDOWN,
	MATRIX,
	RANKING
}

export enum SubscriptionPlanStatus {
	TRIAL = 0,
	SUBSCRIBED,
	UNSUBSCRIBED,
	FREE
}

export enum SurveyRespondentIdentifyBy {
	IP_ADDRESS = 0
}

export enum PollResultVisibility {
	VISIBLE = 0,
	ANONYMOUS,
	PRIVATE
}

export enum ReportQuestionMode {
	ALL = 0,
	MANUAL,
	CURRENT
}

export enum QuestionOptionType {
	BOOL = 0,
	CHAR,
	NUMBER,
	DATE,
	TIME,
	DATETIME,
	TEXT,
	JSON
}

export enum SurveyMemberInviteStatus {
	NA = 0,
	INVITED,
	REGISTERED
}

export enum QuestionOptionKey {
	STEP = 0,
	LEFT_LABEL,
	RIGHT_LABEL,
	TEXT_VALIDATION,
	PLACEHOLDER,
	MULTI_SELECT,
	RANDOMIZE_ROWS,
	RANDOMIZE_COLUMNS
}

export declare type SurveyLogoAlignment = 'l' | 'c' | 'r' | 'le' | 're';
export declare type SurveyLogoSize = 's' | 'm' | 'l' | 'f' | 'o';
export declare type SessionResponseAction = 'upsert' | 'add' | 'remove';
export declare type SurveyCreatorAIResponse = SurveyAIErrorResponse | SurveyCreatorAISurveyResponse | SurveyAIFollowUpResponse;
export declare type SurveyAnalyzeAiSuggestionState = 'resolved' | 'new' | 'discarded';

export declare type InviteTokenResponse = {
	valid: boolean;
	reason: InvalidTokenReason;
	email: string | null;
	userExists: boolean;
};

export declare type RawUserType = {
	email: string;
	firstName: string;
	lastName: string;
	uuid: string;
};

export declare type UserType = {
	email: string;
	firstName: string;
	lastName: string;
	uuid: string;
	color: string;
	role: RoleChoice;
	isRegistered: boolean;
	isActive: boolean;
	hasPassword: boolean;
	avatar: string | null;
	isElevated: boolean;
};

export declare type NotificationSettingsType = {
	productUpdates: boolean;
};

export declare type SurveyStylingLogoType = {
	alignment?: SurveyLogoAlignment;
	size?: SurveyLogoSize;
};

export declare type SurveyStylingBlockStyleType = {
	fontFamilyKey?: string;
	color?: string;
};

export declare type SurveyStylingColorsType = {
	background?: string;
	buttonBackground?: string;
	buttonText?: string;
	accent?: string;
};

export declare type SurveyStylingType = {
	logo?: SurveyStylingLogoType;
	headings?: SurveyStylingBlockStyleType;
	questionTitles?: SurveyStylingBlockStyleType;
	body?: SurveyStylingBlockStyleType;
	colors?: SurveyStylingColorsType;
};

export declare type SurveyTakeActionType = {
	action: SurveyTakeAction;
	targetInfo?: {[key: string]: any};
};

export declare type SurveyType = {
	name: string;
	emoji: string | null;
	creator: UserType;
	uuid: string;
	editUrl: string;
	createdAt: string;
	updatedAt: string;
	state: SurveyState;
	renderedDoc: string;
	shareMode: SurveyShareMode;
	url: string;
	submitLabel: string;
	isTemplate: boolean;
	logic: Array<{[key: string]: any}> | null;
};

export declare type SurveyEditType = SurveyType & {
	surveyDoc: {[key: string]: any};
	defaultReportUuid: string;
	qrCode: string | null;
	hasUnpublishedChanges: boolean;
	embedUrl: string;
};

export declare type SurveyForUserAdminType = SurveyEditType & {
	role: SurveyUserRole;
};

export declare type SurveyForUserAdminWithStatsType = SurveyForUserAdminType & {
	partialResponses: number;
	completedResponses: number;
};

export declare type SurveyEndPageType = {
	uuid: string;
	name: string;
	isDefault: boolean;
	logo: [string, string] | null;
	heading: string;
	renderedContent: string;
};

export declare type SurveyStyleType = {
	logo: string | null;
	styling: SurveyStylingType;
};

export declare type SurveyConfigurationType = {
	identifyBy: SurveyRespondentIdentifyBy;
	allowMultipleResponses: boolean;
	closeDate: string | null;
	redirectUrl: string | null;
	password: string | null;
	hideFromSearchIndex: boolean;
	opengraphTitle: string | null;
	opengraphDescription: string | null;
	showProgressBar: boolean;
	showPoweredBy: boolean;
	responseMode: SurveyResponseMode;
};

export declare type SurveyIntegrationType = {
	uuid: string;
	integrationKey: SurveyIntegrationKey;
	configuration: {[key: string]: any};
	enabled: boolean;
	configured: boolean;
};

export declare type SurveyMemberType = {
	user: UserType;
	responses: number;
	inviteStatus: SurveyMemberInviteStatus;
	role: SurveyUserRole;
};

export declare type SurveyNotificationsType = {
	everyResponse: boolean;
	dailySummary: boolean;
	weeklySummary: boolean;
};

export declare type SurveyMetaVariableType = {
	uuid: string;
	name: string;
	varType: SurveyMetaType;
	defaultCharValue: string | null;
	defaultIntValue: number | null;
	queryParam: string | null;
};

export declare type SurveyQuestionType = {
	uuid: string;
	identifier: string;
	required: boolean;
	questionType: QuestionType;
	limitMax: number | null;
	limitMin: number | null;
	randomizeChoices: boolean;
	choiceBadge: QuestionChoiceBadge;
	displayStyle: QuestionDisplayStyle;
	options: Record<QuestionOptionKey, SurveyQuestionOptionType>;
	choices: Array<QuestionChoiceType>;
	bulkChoices: QuestionBulkChoicesType | null;
	visible: boolean;
	hasPublished: boolean;
	subQuestions: Array<SubSurveyQuestionType>;
	subQuestionEntries: Array<SubQuestionEntryType>;
};

export declare type QuestionBulkChoiceType = {
	label: string;
	uuid: string;
};

export declare type QuestionBulkChoicesType = {
	choices: Array<QuestionBulkChoiceType>;
};

export declare type SurveyQuestionOptionType = {
	key: QuestionOptionKey;
	optionType: QuestionOptionType;
	intValue: number | null;
	textValue: string | null;
	charValue: string | null;
	datetimeValue: string | null;
	jsonValue: {[key: string]: any} | null;
};

export declare type QuestionChoiceType = {
	uuid: string;
	label: string;
	text: string | null;
	value: number | null;
	index: number;
	hasTextOption: boolean;
	isPinned: boolean;
};

export declare type SubSurveyQuestionType = {
	uuid: string;
	label: string;
	subQuestionType: SubQuestionType;
	index: number;
};

export declare type SubQuestionEntryType = {
	uuid: string;
	label: string;
	index: number;
};

export declare type PublishedSurveyType = {
	uuid: string;
	version: number;
	name: string;
	submitLabel: string;
	logic: Array<{[key: string]: any}> | null;
};

export declare type PublishedSurveyStyleType = {
	logo: string | null;
	styling: SurveyStylingType;
};

export declare type PublishedSurveyPageType = {
	uuid: string;
	name: string;
	renderedPage: string;
	questions: Array<PublishedSurveyQuestionType>;
	nextPageLabel: string;
	previousPageLabel: string;
	index: number;
};

export declare type PublishedQuestionChoiceType = {
	uuid: string;
	label: string;
	text: string | null;
	value: number | null;
	index: number;
	hasTextOption: boolean;
	isPinned: boolean;
};

export declare type PublishedSurveyQuestionType = {
	uuid: string;
	identifier: string;
	required: boolean;
	renderedQuestion: string;
	questionType: QuestionType;
	title: string;
	plainTitle: string;
	limitMax: number | null;
	limitMin: number | null;
	randomizeChoices: boolean;
	choiceBadge: QuestionChoiceBadge;
	displayStyle: QuestionDisplayStyle;
	options: Record<QuestionOptionKey, PublishedSurveyQuestionOptionType>;
	choices: Array<PublishedQuestionChoiceType>;
	subQuestions: Array<PublishedSubQuestionType>;
	subEntries: Array<PublishedSubQuestionEntryType>;
	bulkChoices: QuestionBulkChoicesType | null;
	visible: boolean;
};

export declare type PublishedSurveyQuestionOptionType = {
	key: QuestionOptionKey;
	optionType: QuestionOptionType;
	intValue: number | null;
	textValue: string | null;
	charValue: string | null;
	datetimeValue: string | null;
	jsonValue: {[key: string]: any} | null;
};

export declare type PublishedSubQuestionType = {
	uuid: string;
	label: string;
	subQuestionType: SubQuestionType;
	index: number;
};

export declare type PublishedSubQuestionEntryType = {
	uuid: string;
	label: string;
	index: number;
};

export declare type SurveyResponseInputErrorType = {
	questionUuid: string;
	error: string;
	field: string;
	code: SurveyResponseErrorCode;
};

export declare type SessionResponseUpdate = {
	action: SessionResponseAction;
	surveyKey: string;
	sessionKey?: string | null;
};

export declare type SubmittedPageResults = {
	submitted: boolean;
	action: SurveyResponseSubmittedAction;
	inputErrors: Array<SurveyResponseInputErrorType> | null;
	nextPage: PublishedSurveyPageType | null;
	isLastPage: boolean;
	redirectOnCompleteUrl: string | null;
	endPage: SurveyEndPageType | null;
	sessionUpdate: SessionResponseUpdate | null;
};

export declare type ChoiceResponseType = {
	choiceUuid: string;
	text: string | null;
	rank: number | null;
};

export declare type SubResponseType = {
	subQuestionUuid: string;
	subEntryUuid: string;
	selected: boolean | null;
};

export declare type ResponseType = {
	questionUuid: string;
	text: string | null;
	value: number | null;
	choices: Array<ChoiceResponseType> | null;
	numberRange: number | null;
	subResponses: Array<SubResponseType> | null;
};

export declare type SurveySubQuestionResponse = {
	subQuestionUuid: string;
	subEntryUuid: string;
	selected: boolean;
};

export declare type ResponseGroupMetaVariableType = {
	variableUuid: string;
	variableType: SurveyMetaType;
	intValue: number | null;
	charValue: string | null;
};

export declare type ResponseGroupType = {
	surveyUuid: string;
	publishedSurveyUuid: string;
	uuid: string;
	pagePath: Array<string>;
	completion: ResponseGroupCompletion;
	responses: Array<ResponseType>;
	metaVariables: Array<ResponseGroupMetaVariableType>;
	createdAt: string;
	updatedAt: string;
};

export declare type QuestionChoiceModified = {
	modification: 'add' | 'remove' | 'edit' | 'reorder';
	choiceUuid: string;
	fromIndex: number | null;
	toIndex: number | null;
	choice: QuestionChoiceType | null;
};

export declare type SubQuestionModified = {
	modification: 'add' | 'remove' | 'edit' | 'reorder';
	subQuestionUuid: string;
	fromIndex: number | null;
	toIndex: number | null;
	subQuestion: SubSurveyQuestionType | null;
};

export declare type SubQuestionEntryModified = {
	modification: 'add' | 'remove' | 'edit' | 'reorder';
	subQuestionEntryUuid: string;
	fromIndex: number | null;
	toIndex: number | null;
	subQuestionEntry: SubQuestionEntryType | null;
};

export declare type SurveyTemplateTagDict = {
	name: string;
	uuid: string;
};

export declare type SurveyTemplateType = {
	uuid: string;
	useVersion: number | null;
	previewImage: string | null;
	name: string;
	tags: Array<SurveyTemplateTagDict>;
	embedUrl: string;
	numQuestions: number;
	numPages: number;
	estimatedDuration: number;
	description: string;
	emoji: string | null;
};

export declare type SurveyTemplateEditType = SurveyTemplateType & {
	available: boolean;
	tags: Array<string>;
};

export declare type SurveyAIErrorResponse = {
	type: 'error';
	message: string;
};

export declare type SurveyAIFollowUpQuestion = {
	questionText: string;
	multi?: boolean;
	choices?: Array<string>;
};

export declare type SurveyAIFollowUpResponse = {
	type: 'followup';
	questions: Array<SurveyAIFollowUpQuestion>;
};

export declare type SurveyCreatorAIBlock = {
	type: 'paragraph' | 'heading-1' | 'heading-2' | 'heading-3';
	content: string;
};

export declare type SurveyAIQuestionChoice = {
	uuid?: string | null;
	label: string;
	hasText: boolean;
	isPinned?: boolean;
};

export declare type SurveyCreatorAIQuestion = {
	type: 'question';
	title: string;
	required: boolean;
	questionType: 'short_text' | 'long_text' | 'single_select' | 'multi_select' | 'rating' | 'star_rating' | 'nps' | 'dropdown_single' | 'dropdown_multi' | 'matrix';
	choices?: Array<SurveyAIQuestionChoice>;
	rows?: Array<string>;
	options: {[key: string]: any};
};

export declare type SurveyCreatorAINewPage = {
	type: 'newPage';
};

export declare type SurveyCreatorAISurveyResponse = {
	type: 'survey';
	survey: Array<SurveyCreatorAIBlock | SurveyCreatorAIQuestion | SurveyCreatorAINewPage>;
	surveyTitle: string;
	surveyEmoji: string;
};

export declare type SurveyAIQuestionOption = {
	optionName: 'minChoices' | 'maxChoices' | 'minWords' | 'maxWords' | 'stars' | 'scale' | 'required';
	valueType: 'str' | 'int' | 'bool';
	valueIsList: boolean;
	value: string | number | boolean | Array<string | number | boolean>;
};

export declare type SurveyAnalyzeAISuggestionChange = {
	changeType: 'add' | 'edit' | 'remove';
	target: 'choice' | 'choices' | 'title' | 'option';
	choices?: Array<SurveyAIQuestionChoice>;
	text?: string;
	option?: SurveyAIQuestionOption;
};

export declare type SurveyAnalyzeAISuggestionResult = {
	uuid: string;
	state: SurveyAnalyzeAiSuggestionState;
	blockUuid: string;
	questionUuid: string | null;
	reasoning: string;
	changeSummary: string | null;
	changeCategory: 'question_clarity' | 'question_types' | 'survey_flow' | 'grammar';
	change: Array<SurveyAnalyzeAISuggestionChange>;
};

export declare type SurveyAnalyzeAISummaryResult = {
	summaryType: 'length' | 'complexity' | 'overall';
	summary: string;
};

export declare type SurveyAnalyzeAIResponse = {
	version: number;
	type: 'analysis';
	suggestions: Array<SurveyAnalyzeAISuggestionResult>;
	summaries: Array<SurveyAnalyzeAISummaryResult>;
};

export declare type FontFaceType = {
	filePath: string;
	variable?: 'width' | 'weight' | 'both';
	weight?: number | [number, number];
};

export declare type FontFaceMapType = {
	name: string;
	regular: FontFaceType;
	italic?: FontFaceType;
	bold?: FontFaceType;
	boldItalic?: FontFaceType;
};

export declare type PageInfo = {
	page: number;
	totalPages: number;
	numberPerPage: number;
	totalCount: number;
};

export declare type BoardPublicType = {
	name: string;
	uuid: string;
	emoji: string | null;
};

export declare type BoardType = {
	name: string;
	creator: UserType;
	uuid: string;
	emoji: string | null;
	url: string;
	state: BoardState;
	shareMode: BoardShareMode;
	createdAt: string;
	updatedAt: string;
};

export declare type BoardInfoType = BoardType & {
	configuration: BoardConfigurationType;
	canEdit: boolean;
};

export declare type BoardViewType = BoardInfoType & {
	members: Array<UserType>;
	participants: Array<UserType>;
};

export declare type BoardAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	participantsCount: number;
};

export declare type BoardForUserAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	commentCount: number;
	role: BoardUserRole;
};

export declare type BoardConfigurationType = {
	cardLimit: number;
	voteLimit: number;
	hideCards: boolean;
	hideVotes: boolean;
	hideCardAuthors: boolean;
	comments: boolean;
	anonymousCards: boolean;
	closeDate: string | null;
	showActiveUsers: boolean;
	introText: string | null;
	introTitle: string | null;
	introRenderedText: string | null;
	welcomeScreenEnabled: boolean;
};

export declare type BoardColumnType = {
	name: string;
	creator: UserType | null;
	index: number;
	uuid: string;
	emoji: string | null;
	participantsCanAddCards: boolean;
};

export declare type CardType = {
	text: string;
	renderedText: string;
	index: number;
	pinned: boolean;
	uuid: string;
	creator: UserType;
	column: BoardColumnType;
	createdAt: string;
	updatedAt: string;
	votes: Array<[string, string]>;
	comments: Array<CardCommentType>;
	reactions: Array<CardReactionType>;
	linkPreviews: Array<CardLinkPreviewType>;
};

export declare type CardReactionType = {
	emoji: string;
	users: Array<UserType>;
	count: number;
	reactedOn: string;
};

export declare type CardLinkPreviewType = {
	id: number;
	url: string;
	siteName: string | null;
	title: string | null;
	description: string | null;
	image: string | null;
	contentType: string;
	videoType: string | null;
	videoUrl: string | null;
};

export declare type CardCommentType = {
	text: string;
	renderedText: string;
	uuid: string;
	author: UserType;
	createdAt: string;
	updatedAt: string;
	cardUuid: string;
};

export declare type BoardMemberType = {
	user: UserType;
	cards: number;
	votes: number;
	inviteStatus: MemberInviteStatus;
	role: BoardUserRole;
};

export declare type WorkspaceFeatureType = {
	key: string;
};

export declare type WorkspacePlanLimitType = {
	key: string;
	value: number;
};

export declare type SubscriptionType = {
	status: SubscriptionPlanStatus;
	name: string;
	planKey: string;
	isOnTrial: boolean;
	isActive: boolean;
	endOfTrial: string | null;
	endOfSubscription: string | null;
	endOfCycle: string | null;
	hasStripeCustomer: boolean;
};

export declare type WorkspaceType = {
	name: string;
	avatar: string | null;
	uuid: string;
	url: string;
};

export declare type WorkspaceAuthenticatedType = WorkspaceType & {
	planKey: string;
	features: Array<WorkspaceFeatureType>;
	limits: Array<WorkspacePlanLimitType>;
	slackIntegrated: boolean;
};

export declare type WorkspaceSearchResultsType = {
	users: Array<UserType>;
	boards: Array<BoardType>;
	surveys: Array<SurveyType>;
};

export declare type WorkspaceNotificationSettingsType = {
	boardActivity: boolean;
	cardActivity: boolean;
};

export declare type WorkspaceFavoritedFolderType = {
	isRoot: boolean;
	isFolder: true;
	name: string;
	uuid: string;
	favorites: Array<WorkspaceFavoritedSurveyType | WorkspaceFavoritedFolderType>;
	index: number;
};

export declare type WorkspaceFavoritedAbstractType = {
	folderUuid: string | null;
	favoriteType: 'survey';
	uuid: string;
	index: number;
	isFolder: false;
};

export declare type WorkspaceFavoritedSurveyType = WorkspaceFavoritedAbstractType & {
	survey: SurveyType;
};

export declare type PollType = {
	uuid: string;
	creator: UserType;
	question: string;
	resultVisibility: PollResultVisibility;
	choices: Array<PollChoiceType>;
	hasResponses: boolean;
};

export declare type PollChoiceType = {
	text: string;
	index: number;
	uuid: string;
};

export declare type PollResponseType = {
	respondant: UserType | null;
	choiceUuid: string;
	uuid: string | null;
};

export declare type SurveyReportType = {
	uuid: string;
	name: string;
	creator: UserType;
	surveyUuid: string;
	isDefault: boolean;
	questionMode: ReportQuestionMode;
};

export declare type SurveyAggregateStats = {
	views: number;
	partialResponses: number;
	completeResponses: number;
	avgCompletionTime: number;
};

export declare type SurveyReportQuestionInfo = {
	questionUuid: string;
	removed: boolean;
	index: number;
	question: SurveyQuestionType;
	published: PublishedSurveyQuestionType;
};

export declare type SurveyReportInfoType = {
	questions: Array<SurveyReportQuestionInfo>;
	filterables: Array<Filterable>;
	defaultReportUuid: string;
};

export declare type SurveyTabulatedResponseGroup = {
	uuid: string;
	email: string | null;
	knownRespondant: UserType | null;
	publishedSurveyUuid: string | null;
	completion: ResponseGroupCompletion;
	createdAt: string;
	updatedAt: string;
	completedAt: string | null;
	ipAddress: string | null;
	responses: Array<ResponseType>;
	metaVariables: Array<ResponseGroupMetaVariableType>;
};

export declare type QuestionChartDataOptionsPagination = {
	perPage: number;
};

export declare type QuestionChartDataOptions = {
	viewAsPercentage: boolean;
	colors: Array<string> | null;
	npsShowBreakdown: boolean;
	pagination: QuestionChartDataOptionsPagination | null;
	orderBy: string;
	showTable: boolean;
};

export declare type ReportQuestionTextResponse = {
	text: string;
	date: string;
};

export declare type ReportQuestionDataset = {
	series: Array<number> | Array<Array<number>> | null;
	text: Array<ReportQuestionTextResponse> | null;
	labels: Array<string> | null;
	pagination: PageInfo | null;
	totalDatapoints: number;
	datapoints: number;
	offset: number;
};

export declare type ReportQuestionWithData = {
	reportQuestion: ReportQuestionType;
	datasets: Array<ReportQuestionDataset>;
};

export declare type ReportChartingData = {
	reportUuid: string;
	chartData: Array<ReportQuestionWithData>;
	datapoints: number;
	totalDatapoints: number;
};

export declare type ReportQuestionType = {
	type: ReportQuestionChartType;
	index: number;
	questionUuid: string;
	title: string;
	uuid: string;
	options: QuestionChartDataOptions;
};

export declare type FilterVariable = {
	type: 'question' | 'meta';
	id: string;
	questionType: QuestionType | null;
	varType: 'string' | 'datetime' | 'number' | 'list' | 'enum' | 'matrix' | 'ranking';
	multiSelect: boolean;
};

export declare type FilterableChoice = {
	label: string;
	value: string | number;
};

export declare type FilterableSubVariable = {
	label: string;
	value: string;
};

export declare type Filterable = {
	label: string;
	variable: FilterVariable;
	choices: Array<FilterableChoice> | null;
	subVariables: Array<FilterableSubVariable> | null;
	limitMin: number | null;
	limitMax: number | null;
	supportsMulti: boolean;
};

export declare type IntegrationInfoType = {
	integrationName: string;
	integrationKey: string;
	connectedBy: UserType;
};

export declare type SlackConversationChoice = {
	displayName: string;
	subName: string | null;
	conversationId: string;
	image: string | null;
	isChannel: boolean;
	isUser: boolean;
};

export declare type UploadedFileType = {
	url: string;
	uploaded: UserType | null;
	uuid: string;
};
